// @ts-nocheck
import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, ArrowRight } from "lucide-react";
import {
  useMyOrganizations,
} from "@/contexts/MyOrganizationsContext";
import { OrgAvatar, roleLabel } from "@/components/shell/OrgSwitcher";

/**
 * Org-admin home card showing the organization(s) this admin manages, with the
 * active one marked and a quick way to switch / jump into each.
 */
export function YourOrganizationsCard() {
  const ctx = useMyOrganizations();
  const navigate = useNavigate();

  if (!ctx || ctx.isLoading) return null;
  const orgs = ctx.organizations;
  if (!orgs.length) return null;

  const multi = orgs.length > 1;

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-semibold">
          {multi ? "Your organizations" : "Your organization"}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {orgs.map((org) => {
          const isActive = org.id === ctx.activeOrgId;
          return (
            <div
              key={org.id}
              className="flex items-center gap-3 rounded-lg border p-3"
            >
              <OrgAvatar org={org} />
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="truncate font-medium">{org.name}</span>
                  {isActive && (
                    <span className="inline-flex items-center gap-1 rounded-full bg-primary/10 px-2 py-0.5 text-xs font-medium text-primary">
                      <Check className="h-3 w-3" /> Active
                    </span>
                  )}
                </div>
                <div className="truncate text-xs text-muted-foreground">
                  {roleLabel(org.role)}
                </div>
              </div>
              {isActive ? (
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={() => navigate("/admin-dashboard")}
                >
                  Open <ArrowRight className="ml-1 h-4 w-4" />
                </Button>
              ) : (
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => {
                    ctx.setActiveOrgId(org.id);
                    navigate("/admin-dashboard");
                  }}
                >
                  Switch
                </Button>
              )}
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
}

export default YourOrganizationsCard;
